import React, { useEffect, useMemo, useRef } from 'react'
import { Container } from 'reactstrap'
import { orderBy } from 'lodash'
import ImageGallery from 'react-image-gallery'

import { useGlobalContext } from 'hooks/useGlobalContext'

const options = {
  isRTL: false,
  showNav: true,
  infinite: true,
  showIndex: false,
  showBullets: false,
  showThumbnails: true,
  showPlayButton: true,
  useWindowKeyDown: true,
  showFullscreenButton: true,
  slideOnThumbnailOver: false,
  showGalleryPlayButton: false,
  showGalleryFullscreenButton: true,
  thumbnailPosition: 'bottom',
  slideInterval: 10000,
  slideDuration: 500,
  showVideo: {},
}

const Carousel = () => {
  const {
    brochure: { cover, images },
  } = useGlobalContext()
  const ref = useRef(null)

  useEffect(() => {
    if (ref) {
      ref.current.play()
    }
  }, [])

  const items = useMemo(() => {
    const result = [
      {
        original: cover,
        thumbnail: cover,
        originalClass: 'carousel-image',
      },
    ].concat(
      orderBy(images, ['position']).map(({ url }) => ({
        original: url,
        thumbnail: url,
        originalClass: 'carousel-image',
      }))
    )

    return result
  }, [cover, images])

  return (
    <Container>
      <ImageGallery
        ref={ref}
        items={items}
        isRTL={options.isRTL}
        showNav={options.showNav}
        infinite={options.infinite}
        showIndex={options.showIndex}
        showBullets={options.showBullets}
        showThumbnails={options.showThumbnails}
        useWindowKeyDown={options.useWindowKeyDown}
        thumbnailPosition={options.thumbnailPosition}
        slideInterval={parseInt(options.slideInterval)}
        slideDuration={parseInt(options.slideDuration)}
        slideOnThumbnailOver={options.slideOnThumbnailOver}
        showPlayButton={options.showPlayButton && options.showGalleryPlayButton}
        showFullscreenButton={
          options.showFullscreenButton && options.showGalleryFullscreenButton
        }
        additionalClass='app-image-gallery'
      />
    </Container>
  )
}

export default Carousel
